import React, { createContext, useContext, useReducer, Dispatch, ReactNode } from 'react';

interface PackageSuggestionSlice {
  watchList: Record<string, boolean>;
  inputForms: Record<string, string>;
}

type Action =
  | { type: 'UPDATE_WATCHLIST'; payload: { id: string; checked: boolean } }
  | { type: 'UPDATE_INPUT_FORMS'; payload: { id: string; value: string } };

interface PackageSuggestionContextType {
  state: PackageSuggestionSlice;
  dispatch: Dispatch<Action>;
}

const PackageSuggestionContext = createContext<PackageSuggestionContextType | undefined>(undefined);

export const usePackageSuggestionContext = () => {
  const context = useContext(PackageSuggestionContext);
  if (!context) {
    throw new Error('usePackageSuggestion must be used within a PackageSuggestionProvider');
  }
  return context;
};

interface PackageSuggestionProviderProps {
  children: ReactNode;
}

export const PackageSuggestionProvider: React.FC<PackageSuggestionProviderProps> = ({ children }) => {
  const [state, dispatch] = useReducer(packageSuggestionReducer, initialState);

  return <PackageSuggestionContext.Provider value={{ state, dispatch }}>{children}</PackageSuggestionContext.Provider>;
};

const initialState: PackageSuggestionSlice = {
  watchList: {},
  inputForms: {},
};

const packageSuggestionReducer = (state: PackageSuggestionSlice, action: Action): PackageSuggestionSlice => {
  switch (action.type) {
    case 'UPDATE_WATCHLIST':
      const { id, checked } = action.payload;
      return { ...state, watchList: { ...state.watchList, [id]: checked } };
    case 'UPDATE_INPUT_FORMS':
      const { id: inputId, value } = action.payload;
      return { ...state, inputForms: { ...state.inputForms, [inputId]: value } };
    default:
      return state;
  }
};
